import React from "react";
import { RouteNames } from "../../router";
import style from "./FooterNavList.module.css";
import { CustomLink } from "../../ui";

const FOOTER_NAV_ITEMS = [
  { path: RouteNames.HOME, text: "Home" },
  { path: RouteNames.ABOUT, text: "About" },
  { path: RouteNames.PORTFOLIO, text: "Gallery" },
  { path: RouteNames.REVIEWS, text: "Reviews" },
  { path: RouteNames.CONTACTS, text: "Contacts" },
];

export const FooterNavList = () => {
  return (
    <ul className={style.footerNavList}>
      {FOOTER_NAV_ITEMS.map((item) => (
        <li key={item.path}>
          <CustomLink {...item} color="white" />
        </li>
      ))}
    </ul>
  );
};
